import Resource from './Resource';

export default class Locales extends Resource {
	constructor(options={}) {
		let {
			route = 'locales',
			query = {},
		} = options;

		let config = {
			route: route,
			query: query,
		};
		super(config);
		return this;
	}

	get() {
		return this.request();
	}
}
